import Vue from 'vue'
import Vuex from 'vuex'
import type from './modules/type'
import article from './modules/article'
// import consommable from './modules/consommable'
import fournisseur from './modules/fournisseur'
import commande from './modules/commande'
import stock from './modules/stock'
import entre from './modules/entre'
import echange from './modules/echange'
import sortie from './modules/sortie'
import medicament from './modules/medicament'
import vente from './modules/vente'
import inventaire from './modules/inventaire'
import user from './modules/user'
import base_assurance from './modules/base_assurance'
import assurance from './modules/clinique/assurance'
import ordonnance from './modules/clinique/ordonnance'
import parametre from './modules/clinique/parametre'

import auth from './modules/auth'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        type, article, medicament,
        fournisseur, stock, entre, commande,
        sortie, inventaire, vente, auth,
        echange, user, base_assurance, assurance, ordonnance,
        parametre,
    },
    plugins: [createPersistedState()],
})
